import { render, staticRenderFns } from "./settlementXMYTab.vue?vue&type=template&id=e5953c0c&scoped=true&"
import script from "./settlementXMYTab.vue?vue&type=script&lang=js&"
export * from "./settlementXMYTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5953c0c",
  null
  
)

export default component.exports